import { baseApi } from "./baseApi";

const VENDOR_QUOTATION_EXCEL_LIST_BASE_URL = "/vendor-quotation-excel";

export const vendorQuotationExcelApi = baseApi.injectEndpoints({
  tagTypes: ["VendorQuotationExcel"],
  endpoints: (build) => ({
    addVendorQuotationExcel: build.mutation({
      query: (body) => ({
        url: VENDOR_QUOTATION_EXCEL_LIST_BASE_URL,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "VendorQuotationExcel", id: "LIST" }],
    }),

    assignLeadToExcel: build.mutation({
      query: ({ id, vendorLead }) => ({
        url: `${VENDOR_QUOTATION_EXCEL_LIST_BASE_URL}/${id}/assign-leads`,
        method: "PATCH",
        body: { vendorLead },
      }),
      invalidatesTags: [{ type: "VendorQuotationExcel", id: "LIST" }],
    }),

    addVendorQuotationExcelSendExcelMail: build.mutation({
      query: (body) => ({
        url: `${VENDOR_QUOTATION_EXCEL_LIST_BASE_URL}/send-excel-mail`,
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "VendorQuotationExcel", id: "LIST" },
        { type: "Note", id: "LIST" },
      ],
    }),

    addVendorProfileQuotationExcelSendExcelMail: build.mutation({
      query: (body) => ({
        url: `${VENDOR_QUOTATION_EXCEL_LIST_BASE_URL}/send-vendor-profile-excel-mail`,
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "VendorQuotationExcel", id: "LIST" },
        { type: "Note", id: "LIST" },
      ],
    }),

    listVendorQuotationExcels: build.query({
      query: (params) => ({
        url: VENDOR_QUOTATION_EXCEL_LIST_BASE_URL,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.data.map(({ _id }) => ({
                type: "VendorQuotationExcel",
                id: _id,
              })),
              { type: "VendorQuotationExcel", id: "LIST" },
            ]
          : [{ type: "VendorQuotationExcel", id: "LIST" }],
    }),

    getDDLVendorQuotationExcelList: build.query({
      query: (params) => ({
        url: `${VENDOR_QUOTATION_EXCEL_LIST_BASE_URL}/ddl`,
        params,
      }),
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ _id }) => ({
                type: "VendorQuotationExcel",
                id: _id,
              })),
              { type: "VendorQuotationExcel", id: "DDL" },
            ]
          : [{ type: "VendorQuotationExcel", id: "DDL" }],
    }),

    getVendorQuotationExcelDetail: build.query({
      query: (id) => `${VENDOR_QUOTATION_EXCEL_LIST_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "VendorQuotationExcel", id },
        { type: "VendorQuotationExcel", id: "LIST" },
      ],
    }),

    updateVendorQuotationExcel: build.mutation({
      query: ({ _id, ...body }) => ({
        url: `${VENDOR_QUOTATION_EXCEL_LIST_BASE_URL}/${_id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: (result, error, { _id: id }) => [
        { type: "VendorQuotationExcel", id },
        { type: "VendorQuotationExcel", id: "LIST" },
      ],
    }),

    searchVendorQuotationExcels: build.query({
      query: ({ q }) => ({
        url: `${VENDOR_QUOTATION_EXCEL_LIST_BASE_URL}/search`,
        params: { q },
      }),
    }),
    getVendorQuotationExcelsByLead: build.query({
      query: (vendorLeadId) => ({
        url: `${VENDOR_QUOTATION_EXCEL_LIST_BASE_URL}/by-lead/${vendorLeadId}`,
      }),
      providesTags: [{ type: "VendorQuotationExcel", id: "BY_LEAD" }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useAddVendorQuotationExcelMutation,
  useAddVendorQuotationExcelSendExcelMailMutation,
  useListVendorQuotationExcelsQuery,
  useLazyListVendorQuotationExcelsQuery,
  useLazyGetDDLVendorQuotationExcelListQuery,
  useGetVendorQuotationExcelDetailQuery,
  useUpdateVendorQuotationExcelMutation,
  useLazySearchVendorQuotationExcelsQuery,
  useAssignLeadToExcelMutation,
  useLazyGetVendorQuotationExcelsByLeadQuery,
  useAddVendorProfileQuotationExcelSendExcelMailMutation,
} = vendorQuotationExcelApi;
